export default __webpack_public_path__ + "static/media/ZASKO.4cdf623a.png";